export default __webpack_public_path__ + "static/media/pisína beton me monopanti ypercheilisi2.07a64b7e.webp";